import styled from "styled-components"

export const SearchWrapper = styled.div`
  width: ${({ width }) => width};
  margin: ${({ margin }) => margin};
`
